export enum EYesNo {
  Yes = 'Yes',
  No = 'No',
}
export enum EYesNoBlank {
  Yes = 'Yes',
  No = 'No',
  Blank = 'Blank'
}
